import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import auditsReducer from "./slices/auditSlice";
import incidentsReducer from "./slices/incidentsSlice";
import authReducer from "./slices/authSlice";
import profileReducer from "./slices/profileSlice";
import checklistReducer from "./slices/checklistSlice";
import templateReducer from "./slices/templateSlice";
import userAuditReducer from "./slices/userAuditSlice";
import areaReducer from "./slices/areaSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile:profileReducer,
    user: userReducer,
    userAudit: userAuditReducer,
    audit: auditsReducer,
    incidents: incidentsReducer,
    template: templateReducer,
    checklist: checklistReducer,
    area: areaReducer,
  },
});
